class ProductCardChooseOptions {
	constructor() {
		this.modal = null
		
		addEventDelegate({
			selector: '[data-product-choose-options]',
			handler: (e, target) => {
				e.preventDefault()
				this.target = target
				this.target.classList.add('btn--loading')
				const productHandle = this.target.dataset.productChooseOptions
				// Optional pre-selected variant id, set by product-card-swatch-swap.js when
				// the modal is opened via a swatch click. Consume + clear so subsequent
				// direct ATC clicks aren't affected.
				const preselectVariantId = this.target.dataset.preselectVariantId
				if (preselectVariantId) delete this.target.dataset.preselectVariantId
				if (productHandle) this.fetchHtml(productHandle, preselectVariantId)
			}
		})

		window.FoxThemeEvents.subscribe(`ON_ITEM_ADDED`, () => {
			if (this.modal) this.modal.hide()
		})
	}

	fetchHtml(productHandle, preselectVariantId) {
		loadAssets([window.FoxThemeStyles.product], 'pcard-choose-options')
		const fetchOpts = {url: `${window.FoxThemeSettings.base_url}products/${productHandle}`}
		if (preselectVariantId) fetchOpts.params = { variant: preselectVariantId }
		fetchSection('pcard-choose-options', fetchOpts).then(html => {
			this.modal = html.querySelector('modal-dialog')
			document.body.appendChild(this.modal)
			loadAssets([window.FoxThemeScripts.variantsPicker], 'variant-picker', () => {
				this.modal && this.modal.show(this.target)
				this.target.classList.remove('btn--loading')
				if (Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init()
				}
				this.handleClose()
			})
		}).catch(console.error)
	}

	handleClose() {
		if (!this.modal) return
		this.modal.addEventListener('close', () => {
			this.modal.remove()
		})
	}
}

new ProductCardChooseOptions()